import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import {
  setConnectInformation,
  resetConnectInformation,
} from 'app/ducks/connect/actions';

import HeaderCenter from 'app/components/layout/HeaderCenter/index';
import ConnectForm from './components/ConnectForm';

interface IAuthenticationConnectLayoutProps {
  actions: any;
  authentication: any;
  match: any;
}
const authentication = (state) => state.authentication;
export const selector = createStructuredSelector({ authentication });
export const actions = {
  setConnectInformation,
  resetConnectInformation,
};

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
}))
export default class AuthenticationConnectLayout extends React.Component<IAuthenticationConnectLayoutProps> {
  static defaultProps = {
    actions: {},
    authentication: undefined,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <div className="container login-app m-h-100">
        <div className="row justify-content-center">
          <div className="col col-12 col-md-8 col-lg-6 col-xlg-5">
            <HeaderCenter logoLeft />
            <div className="row">
              <div className="col">
                <Route
                  exact
                  path={['/connect/:provider', '/connect/:provider/:prefilled']}
                  render={(): React.ReactNode => (
                    <ConnectForm
                      {...this.props}
                      isLoggedIn={this.props.authentication.isLoggedIn}
                      isLoading={this.props.authentication.isLoading}
                      hasLoaded={this.props.authentication.hasLoaded}
                      hasFailed={this.props.authentication.hasFailed}
                      backendErrors={this.props.authentication.backendErrors}
                      actions={this.props.actions}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
